import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface DeleteIncomeTypeParams {
  id: string;
}

const deleteIncomeType: MutationFunction<
  boolean,
  DeleteIncomeTypeParams
> = async ({ id }) => {
  if (isMockServices()) return await mock(true);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/income-types/${id}`,
    {
      method: 'DELETE',
    },
  );

  if (response.data) return response.data.success;
  throw new Error('Failed to delete income type');
};

export default deleteIncomeType;
